module.exports = __webpack_public_path__ + "static/media/filter-column.89bccebd.svg";